"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const core_1 = require("@material-ui/core");
const Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
const StaticAlert = (props) => {
    const { children, severity, icon } = props;
    return (react_1.default.createElement(core_1.Box, Object.assign({}, props),
        react_1.default.createElement(Alert_1.default, { severity: severity, icon: icon }, children)));
};
StaticAlert.propTypes = {
    ...core_1.Box.propTypes,
    severity: prop_types_1.default.string.isRequired,
    icon: prop_types_1.default.any,
};
StaticAlert.defaultProps = {
    ...core_1.Box.defaultProps,
    severity: 'error',
};
exports.default = StaticAlert;
